import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ProfileDocumentsDataTable from './ProfileDocumentsDataTable';
import { indexSupportDocumentRequest } from '../../../requests/supportDocuments';
import { indexRiskPreventionDocumentRequest } from '../../../requests/riskPreventionDocuments';

const SupportDocumentProfileIndex = () => {
  const allowedDocumentTypes = [
    'voting_workers',
    'committee_hygiene_safety',
    'work_accidents',
    'election_representatives_hygiene_safety',
    'meeting_hygiene_safety'
  ];

  const filterFunction = data => {
    return data.filter(item => item.document_type !== null && allowedDocumentTypes.includes(item.document_type));
  };

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col>
          <h2 className="mb-3 mt-3">Documentación de Apoyo</h2>
        </Col>
      </Row>

      <ProfileDocumentsDataTable
        endpointIndex={indexSupportDocumentRequest}
        additionalEndpoint={indexRiskPreventionDocumentRequest}
        additionalFilter={filterFunction}
        preName="support_documents"
      />
    </>
  );
};

export default SupportDocumentProfileIndex;
